// Utilitaires pour la navigation et le scrollTo
export const scrollToSection = (sectionId: string, offset: number = 80) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// Fonction pour gérer les liens d'ancrage avec navigation cross-page
export const handleAnchorClick = (
  event: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  navigate?: (path: string) => void,
  currentPath?: string
) => {
  // Si c'est un lien d'ancrage (commence par #)
  if (href.startsWith('#')) {
    event.preventDefault();
    const sectionId = href.substring(1);
    
    // Si on est déjà sur la page d'accueil, scroller directement
    if (currentPath === '/') {
      scrollToSection(sectionId);
    } else {
      // Sinon, naviguer vers la page d'accueil avec l'ancre
      if (navigate) {
        navigate(`/${href}`);
      }
    }
    return;
  }
  
  // Si c'est un lien vers une autre page
  if (navigate && !href.startsWith('http')) {
    event.preventDefault();
    navigate(href);
    return;
  }
  
  // Laisser le comportement par défaut pour les liens externes
};

// Fonction pour scroller vers une ancre après navigation
export const handleAnchorFromURL = (hash: string) => {
  if (hash && hash.startsWith('#')) {
    const sectionId = hash.substring(1);
    // Petit délai pour s'assurer que la page est rendue
    setTimeout(() => {
      scrollToSection(sectionId);
    }, 100);
  }
};

// Types pour la navigation
export interface NavigationItem {
  key: string;
  label: string;
  href: string;
  external?: boolean;
}

export const navigationItems: NavigationItem[] = [
  {
    key: 'parcours',
    label: 'Les parcours',
    href: '/#parcours'
  },
  {
    key: 'projet',
    label: 'Le projet AndyKapp',
    href: '/#projet'
  },
  // {
  //   key: 'handicaps',
  //   label: 'Les handicaps',
  //   href: '/handicaps'
  // }
];

// Fonction pour déterminer si on est sur une page spécifique
export const isCurrentPage = (pathname: string, href: string): boolean => {
  if (href.startsWith('#')) {
    return pathname === '/'; // Les ancres sont sur la page d'accueil
  }
  return pathname === href;
};